import { Spin } from 'antd';
import React, { Suspense, useEffect } from 'react';
import { Route, Routes, useLocation } from 'react-router-dom';
import Cookies from 'js-cookie';
import Users from './users';
import Verification from './verification';
import Roles from './roles';
import ParentCompany from './parentCompany';
import SupportTickets from './supportTickets';
import Pages from './pages';
import Faq from './faq';
import AppBanners from './appBanners';
import ForexPairs from './forexPairs';
import SellPairs from './sellPairs';
import SellAssets from './sellAssets';
import Assets from './asset';
import Notifications from './notifications';
import Deposit from './deposit';
import Withdrawal from './withdrawal';
// import BonusCode from './bonusCode';
import ConfigurePaymentGateways from './configurePaymentGateways';
import StuckPayments from './stuckPayments';
import withAdminLayout from '../../layout/withAdminLayout';
import SendEmail from './sendEmail';
import TreasureHunt from './treasure-hunt';
import { Constants } from '../../utility/constants';
import { useAuthenticationStore } from '../../store/authentication/authenticationStore';

const Admin = React.memo(() => {
  const { pathname } = useLocation();
  const isLoading = useAuthenticationStore((state) => state.loading);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return (
    <Suspense
      fallback={
        <div className="spin">
          <Spin />
        </div>
      }
    >
      {isLoading && (
        <div
          style={{
            position: 'absolute',
            background: 'rgb(255 255 255 / 50%)',
            height: '100%',
            width: '100%',
            zIndex: 999,
            textAlign: 'center',
            verticalAlign: 'middle',
          }}
        >
          <Spin />
        </div>
      )}
      <Routes>
        <Route index path="/*" element={<Pages />} />
        {[Constants.admin.role.superAdmin].includes(Cookies.get(`role`)) && (
          <Route path="roles/*" element={<Roles />} />
        )}
         {[Constants.admin.role.superAdmin].includes(Cookies.get(`role`)) && (
          <Route path="parent-company/*" element={<ParentCompany />} />
        )}
        {[Constants.admin.role.superAdmin, Constants.admin.role.support].includes(Cookies.get(`role`)) && (
          <Route path="support/*" element={<SupportTickets />} />
        )}
        <Route path="users/*" element={<Users />} />
        <Route path="verification/*" element={<Verification />} />
        <Route path="pages/*" element={<Pages />} />
        <Route path="faq/*" element={<Faq />} />
        <Route path="app-banners/*" element={<AppBanners />} />
        <Route path="pairs/*" element={<ForexPairs />} />
        <Route path="sell-pairs/*" element={<SellPairs />} />
        <Route path="sell-assets/*" element={<SellAssets />} />
        <Route path="assets/*" element={<Assets />} />
        <Route path="notifications/*" element={<Notifications />} />
        <Route path="deposit/*" element={<Deposit />} />
        <Route path="withdrawal/*" element={<Withdrawal />} />
        <Route path="configure-payment-gateways/*" element={<ConfigurePaymentGateways />} />
        <Route path="stuck-payments/*" element={<StuckPayments />} />
        {/* <Route path="bonus-code/*" element={<BonusCode />} /> */}
        {[Constants.admin.role.superAdmin, Constants.admin.role.support].includes(Cookies.get(`role`)) && (
          <Route path="send-email/*" element={<SendEmail />} />
        )}
        {[Constants.admin.role.superAdmin].includes(Cookies.get(`role`)) && (
          <Route path="treasure-hunt/*" element={<TreasureHunt />} />
        )}
      </Routes>
    </Suspense>
  );
});

Admin.displayName = 'Admin';

export default withAdminLayout(Admin);
